import { render, staticRenderFns } from "./WorkplaceSafety.vue?vue&type=template&id=3a7b00f5&scoped=true&"
import script from "./WorkplaceSafety.vue?vue&type=script&lang=js&"
export * from "./WorkplaceSafety.vue?vue&type=script&lang=js&"
import style0 from "./WorkplaceSafety.vue?vue&type=style&index=0&id=3a7b00f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b00f5",
  null
  
)

export default component.exports